import { Loading } from '../../Components/Loading/Loading';
import * as KeyNames from '../../api/KeyNames';

export function Logout() {
    localStorage.clear(KeyNames.SessionData);
    localStorage.clear(KeyNames.SessionData + " email"); //temporal
    localStorage.clear(KeyNames.PathName);
    sessionStorage.clear();
    document.location.reload(); //Deletes useQuery  
    return (<Loading />)
}
